import { useNavigate } from 'react-router-dom';
import { X } from '@/components/ui/icons';

/**
 * Fixed top-right close button for the full-screen auth views (sign in / sign
 * up). Returns to the home route so users can dismiss the auth screen without
 * relying on browser back.
 */
export function AuthCloseButton() {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      aria-label="Close"
      onClick={() => navigate('/')}
      className="fixed right-4 top-4 z-50 flex h-9 w-9 items-center justify-center rounded-full text-gray-400 transition-colors hover:bg-telekinesis-neutral-800 hover:text-white"
    >
      <X className="h-5 w-5" />
    </button>
  );
}
